interface Option {
  value: string;
  label: string;
}

interface FilterGroupProps {
  label: string;
  options: Option[];
  selected: string[];
  onToggle: (value: string) => void;
}

export default function FilterGroup({
  label,
  options,
  selected,
  onToggle,
}: FilterGroupProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-4">
      <span className="shrink-0 text-sm text-foreground-500 sm:w-20 sm:pt-1">
        {label}
      </span>
      <div className="flex flex-wrap gap-2">
        {options.map((opt) => {
          const active = selected.includes(opt.value);
          return (
            <button
              key={opt.value}
              type="button"
              onClick={() => onToggle(opt.value)}
              className={`px-3 h-8 flex items-center rounded-md text-sm whitespace-nowrap cursor-pointer transition-colors ${
                active
                  ? "bg-primary-500 text-background-50 border border-primary-500"
                  : "bg-background-50 text-foreground-700 border border-background-200 hover:border-primary-300"
              }`}
            >
              {opt.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}